<template>
  <div class="news_main">
    <div class="main-left" v-if="news.title">
      <img class="left_img" :src="news.images ? news.images : newsImg" alt="" />
      <div class="left_new">
        <div class="title">{{ news.title }}</div>
        <img
          src="../assets/image/home/go-detail.png"
          alt=""
          @click="handleGotoDetail(news)"
        />
        <!--        <div class="news_text">{{news.newsText}}</div>-->
        <!--        <div class="news_date">{{news.publishTime | activityTime}}</div>-->
        <!--        <div class="news_dtl" @click="handleGotoDetail(news)">阅读详情 ></div>-->
      </div>
    </div>
    <div class="more" @click="handleGotoList(news)">更多></div>
    <div class="main-right">
      <div class="list_item" v-for="(item, index) in list" :key="index">
        <div class="title_line">
          <div class="title_left">
            <div class="title">{{ item.title }}</div>
          </div>
        </div>
        <div class="right_content" v-dompurify-html="item.summary">
          <!-- {{item.newsText}} -->
        </div>
        <div class="line"></div>
        <div class="time-line">
          <div class="date">
            <div class="date-day">{{ item.publishTime | activityTimeDay }}</div>
            <div class="date-mon">{{ item.publishTime | activityTime }}</div>
          </div>

          <img
            @click="handleGotoDetail(item)"
            src="../assets/image/home/go-detail.png"
            alt=""
          />
        </div>
      </div>

      <!--      <div class="news_dtl" @click="handleGotoList(list[0])">更多 ></div>-->
    </div>
  </div>
</template>

<script>
import news from "../assets/image/home/news.png";

export default {
  name: "HomeNewsList",
  props: {
    msg: String,
    list: {
      type: Array,
    },
    news: {
      type: Object,
    },
  },
  filters: {
    activityTime: function (value) {
      if (value == null || value == "" || value == undefined) {
        return "";
      } else {
        let date = new Date(value);
        let Y = date.getFullYear() + "-";
        let M =
          date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1;

        return Y + M;
      }
    }, //时间戳转换
    activityTimeDay: function (value) {
      if (value == null || value == "" || value == undefined) {
        return "";
      } else {
        let date = new Date(value);
        let D =
          (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
        return D;
      }
    }, //时间戳转换
  },
  data() {
    return {
      newsImg: news,
    };
  },
  methods: {
    async changePv(params) {
      const res = await this.API.operateManage.portalNewsUpdateFn(params);
    },
    handleGotoList(list) {
      console.log(list);
      this.$router.push({
        path: "/newsCenter",
        query: { type: list.channelId },
      });
      document.documentElement.scrollTop = 0;
    },
    handleGotoDetail(val) {
      let params = {
        id: val.id,
        pv: Number(val.pv) + 1,
      };
      this.changePv(params).then(() => {
        this.$router.push(
          `/newsDetail?id=${val.id}&channelId=${val.channelId}`
        );
      });

      document.documentElement.scrollTop = 0;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.news_main {
  display: flex;
  width: 100%;
  position: relative;
  align-items: center;
  justify-content: center;
}
.more {
  position: absolute;
  right: 90px;
  top: -22px;
  font-family: "Microsoft YaHei";
  font-weight: 400;
  font-size: 14px;
  text-align: center;
  color: #0052d9;
  cursor: pointer;
}

.main-left {
  // width: 696px;
  flex: 1;//新闻样式按要求优化
  background: #ffffff;
  box-shadow: 0px 2px 12px rgba(63, 104, 158, 0.19);
  opacity: 1;

  .left_img {
    // width: 696px;
    width: 100%;//新闻样式按要求优化
    height: 510px;
  }

  .left_new {
    padding: 20px 35px;
    height: 64px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: rgba(7, 12, 30, 0.8);
    margin-top: -64px;
    position: relative;
    img {
      width: 31px;
      cursor: pointer;
    }
    .title {
      opacity: 1;
      cursor: pointer;
      font-family: "Microsoft YaHei Bold";
      font-weight: 700;
      font-size: 2vh;
      line-height: 24px;
      text-align: left;
      color: #fff;
    }

    .news_text {
      margin-top: 14px;
      width: 90%;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-box-orient: vertical;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 24px;
      color: #495770;
      opacity: 1;
    }

    .news_date {
      margin-top: 30px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 24px;
      color: #495770;
      opacity: 1;
    }
  }
}

.news_dtl {
  margin-top: 34px;
  cursor: pointer;
  width: 106px;
  height: 42px;
  border: 1px solid #0052d9;
  opacity: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #0052d9;
}

.main-right {
  // margin-left: 16px;
  margin-left: 36px;
  gap: 16px;
  // padding: 0 24px;
  /*width: calc(100% - 696px);*/
  opacity: 1;
  border-radius: 6px;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  flex: 1;//新闻样式按要求优化
  .list_item:hover {
    background: #0b2242;
    color: #fff;
    .title_line {
      .title {
        color: #fff;
      }
      .date {
        color: #fff;
      }
    }
    .right_content {
      color: #ffffff;
    }
    .time-line {
      .date-day {
        color: #fff;
      }
      .date-mon {
        color: #fff;
      }
    }
  }
  .list_item:nth-child(1),
  .list_item:nth-child(2) {
    margin-bottom: 1%;
  }
  .list_item {
    border-bottom: 1px solid #ebebeb;
    opacity: 1;
    // width: 414px;
    // height: 49%;
    width: 45%;//新闻样式按要求优化
    background: #fff;
    // margin-right: 28px;
    box-shadow: 0 3px 6px rgba(118, 116, 132, 0.16);
    padding: 31px 37px;
    .title_line {
      display: flex;
      justify-content: space-between;
      .title_left {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
      }

      .title {
        font-family: "Microsoft YaHei Bold";
        font-weight: 700;
        font-size: 18px;
        text-align: left;
        color: #1d2129;
        width: 98%;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
      }

      .date {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 24px;
        color: #999999;
        opacity: 1;
      }
    }

    .right_content {
      margin-top: 16px;
      margin-bottom: 18px;
      width: 95%;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-box-orient: vertical;
      opacity: 1;
      font-family: "Microsoft YaHei";
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      text-align: left;
      color: #4e5969;
    }
    .line {
      width: 100%;
      height: 0;
      background: transparent;
      border: 1px solid #dcdcdc;
    }
    .time-line {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 20px;
      img {
        width: 31px;
        cursor: pointer;
      }
      .date-day {
        font-family: "Microsoft YaHei";
        font-weight: 400;
        font-size: 28px;
        line-height: 24px;
        text-align: left;
        color: #4e5969;
      }
      .date-mon {
        font-family: "Microsoft YaHei";
        font-weight: 400;
        font-size: 14px;
        line-height: 24px;
        text-align: left;
        color: #4e5969;
      }
    }
  }
}
// @media screen and(max-width: 1366px) {


//   .main-left {
//     width: 496px;
//     .left_img {
//       width: 496px;
//       height: 364px;
//     }
//   }
//   .main-right {
//     margin-left: 16px;
//     padding: 0;
//     /*width: calc(100% - 496px);*/

//     .list_item:nth-child(1),
//     .list_item:nth-child(2) {
//       margin-bottom: 3%!important;
//     }
//     .list_item {
//       width: 255.54px;
//       height: 173px;
//       padding: 14px 18px;
//       .title_line {
//         .title {
//           font-size: 16px;
//         }

//         .date {
//           font-size: 12px;
//           font-family: Microsoft YaHei;
//           font-weight: 400;
//           line-height: 24px;
//           color: #999999;
//           opacity: 1;
//         }
//       }
//       .right_content {
//         margin-top: 12px;
//         margin-bottom: 14px;
//         width: 95%;
//         display: -webkit-box;
//         -webkit-line-clamp: 2;
//         overflow: hidden;
//         text-overflow: ellipsis;
//         -webkit-box-orient: vertical;
//         opacity: 1;
//         font-family: "Microsoft YaHei";
//         font-weight: 400;
//         font-size: 16px;
//         line-height: 24px;
//         text-align: left;
//         color: #4e5969;
//       }
//       .line {
//         width: 100%;
//         height: 0;
//         background: transparent;
//         border: 1px solid #dcdcdc;
//       }
//       .time-line {
//         display: flex;
//         align-items: center;
//         justify-content: space-between;
//         margin-top: 14px;
//         img {
//           width: 24px;
//           cursor: pointer;
//         }
//         .date-day {
//           font-family: "Microsoft YaHei";
//           font-weight: 400;
//           font-size: 22px;
//           line-height: 24px;
//           text-align: left;
//           color: #4e5969;
//         }
//         .date-mon {
//           font-family: "Microsoft YaHei";
//           font-weight: 400;
//           font-size: 12px;
//           line-height: 18px;
//           text-align: left;
//           color: #4e5969;
//         }
//       }
//     }
//   }
// }
</style>
